import { useState, useCallback, useEffect, useMemo } from 'react';
import i18next from 'i18next';
import constate from '../../common/lib/constate';

function useLanguage() {
  const [isLanguageMenu, setIsLanguageMenu] = useState(false);
  const [language, setLanguage] = useState({});

  const [languages] = useState([
    { name: 'Nederlands', flagPath: 'dutch', lng: 'nl' },
    { name: 'English', flagPath: 'english', lng: 'enGB' },
    { name: 'Deutsch', flagPath: 'german', lng: 'de' },
  ]);

  const setCurrentLanguage = useCallback(() => {
    let language = null;
    languages.map(item => {
      if (i18next.language.includes(item.lng)) {
        language = item;
      }
    });
    if (!language) {
      language = languages.find(item => item.name === 'English');
    }
    setLanguage(language);
  }, []);

  useEffect(() => {
    setCurrentLanguage();
  }, []);

  return useMemo(
    () => ({
      isLanguageMenu,
      setIsLanguageMenu,
      language,
      setLanguage,
      languages,
      setCurrentLanguage,
    }),
    [isLanguageMenu, setIsLanguageMenu, language, setLanguage, languages, setCurrentLanguage]
  );
}

export const useLanguageContext = constate(useLanguage);

const LanguageContext = {
  Provider: useLanguageContext.Provider,
};

export default LanguageContext;
